// extracted by mini-css-extract-plugin
export default {"resetPasswordResultContainer":"ResetPasswordResult_resetPasswordResultContainer__aI9dn"};